export const data2 = [
	{
		id: 1,
		project: "EduExp App (The Google Solution Challenge)",
		description: "Designed and developed a mobile application using Dart, Flutter, Firebase, React JS, JavaScript, Visual Studio Code, for teachers around the world to share their experiences with teaching, so that the quality of education can improve around the world, especially in developing countries. Users can post their experiences through a video or a photograph, and people can react to these posts through Real-Time Interaction.",
	},
	{
		id: 2,
		project: "The Pokémon Game",
		description: "Designed and developed a real-life Pokémon game using : Java, Combined use of Classes, Objects, Data Structures, Inheritance and Polymorphism through Object-oriented programming in Java, IntelliJ, where user gets to select a starting Pokémon, then construct a Map and a Trainer object. The user has options of buying Potions, Poke Balls, entering a Pokémon Hospital to fight with other Pokémon.",
	},
	{
		id: 3,
		project: "Book Store System",
		description: "Developed a system using Data Structures in Python (Stacks, Queues, Lists, Deques, Linked-Lists, and Hash-Tables) and Visual Studio Code that allows user to search any book from the library database, add, remove, replace it into the shopping cart and eventually buying it.",
	}
];